import { render, staticRenderFns } from "./Ficheros.vue?vue&type=template&id=022b357c&"
import script from "./Ficheros.vue?vue&type=script&lang=ts&"
export * from "./Ficheros.vue?vue&type=script&lang=ts&"
import style0 from "./Ficheros.vue?vue&type=style&index=0&id=022b357c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports